export { default } from './CardActionArea';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/CardActionArea/index.js
// module id = 789
// module chunks = 121